export type PhaseDisplayItem =
  | { kind: "phase"; phase: any }
  | { kind: "group"; groupName: string; phases: any[] };

export function groupPhasesByProductGroup(phases: any[]): PhaseDisplayItem[] {
  const groupMap = new Map<string, { name: string; groupOrdering: number; phases: any[] }>();
  const ungrouped: { phase: any; ordering: number }[] = [];

  for (const phase of phases) {
    const group = phase.proposalProductGroup;
    if (group?.id) {
      const existing = groupMap.get(group.id);
      if (existing) {
        existing.phases.push(phase);
      } else {
        groupMap.set(group.id, {
          name: group.name,
          groupOrdering: group.ordering ?? 0,
          phases: [phase],
        });
      }
    } else {
      ungrouped.push({ phase, ordering: phase.ordering ?? 0 });
    }
  }

  for (const group of groupMap.values()) {
    group.phases.sort((a, b) => (a.ordering ?? 0) - (b.ordering ?? 0));
  }

  const all: { item: PhaseDisplayItem; ordering: number }[] = [
    ...ungrouped.map((u) => ({
      item: { kind: "phase" as const, phase: u.phase },
      ordering: u.ordering,
    })),
    ...[...groupMap.values()].map((g) => ({
      item: { kind: "group" as const, groupName: g.name, phases: g.phases },
      ordering: g.groupOrdering,
    })),
  ];

  all.sort((a, b) => a.ordering - b.ordering);

  return all.map((entry) => entry.item);
}
